import React, { useEffect, useMemo, useRef } from 'react';

// Countdown sem setInterval próprio.
// O parent (AutoBlockActiveBans) tick um único setInterval e passa `now` via prop.
// Memoizado para evitar re-render quando a string formatada não muda.

function format(remaining) {
  if (remaining <= 0) return null;
  const hh = String(Math.floor(remaining / 3600)).padStart(2, '0');
  const mm = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
  const ss = String(remaining % 60).padStart(2, '0');
  return hh === '00' ? `${mm}:${ss}` : `${hh}:${mm}:${ss}`;
}

function Countdown({ now, expiresAt, onExpire }) {
  const expiresMs = useMemo(() => (expiresAt ? new Date(expiresAt).getTime() : null), [expiresAt]);
  const onExpireRef = useRef(onExpire);
  useEffect(() => { onExpireRef.current = onExpire; }, [onExpire]);

  if (!expiresMs) {
    return <span className="ab-countdown ab-countdown-unknown">—</span>;
  }

  const remaining = Math.max(0, Math.round((expiresMs - now) / 1000));

  useEffect(() => {
    if (remaining === 0 && onExpireRef.current) {
      onExpireRef.current();
    }
  }, [remaining]);

  if (remaining === 0) {
    return <span className="ab-countdown ab-countdown-expired">expirado</span>;
  }

  const formatted = format(remaining);
  const isUrgent = remaining <= 60;
  const className = `ab-countdown${isUrgent ? ' ab-countdown-urgent' : ''}`;
  return <span className={className}>{formatted}</span>;
}

export default React.memo(Countdown);
